import { render, staticRenderFns } from "./matchwork.vue?vue&type=template&id=6b624a8e&scoped=true"
import script from "./matchwork.vue?vue&type=script&lang=js"
export * from "./matchwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b624a8e",
  null
  
)

export default component.exports